Ext.define('SA.view.MessageSpinner', {
    alias: 'widget.message-spinner',
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-message-spinner',
    padding: '8 12',

    initComponent() {
        this.items = [
            {
                xtype: 'spinner',
                width: 24
            }, {
                xtype: 'component',
                cls: 'sa-message-spinner-text',
                html: Ext.htmlEncode(this.text),
                margin: `0 0 0 8`
            }
        ];

        this.callParent();
    }
});